export const extractBuyingIngredientsFromList = arr => {
  const safeArr = arr ?? [];
  return safeArr
    .map(item => item?.buyingToolsIngredients)
    .filter(item => {
      // Check if it's an object (not array) and not empty
      return (
        item &&
        typeof item === 'object' &&
        item !== null &&
        !Array.isArray(item) &&
        Object.keys(item).length > 0
      );
    });
};
